// extracted by mini-css-extract-plugin
export default {"container":"sca-z","oos":"tca-z","oosUx":"uca-z","selected":"vca-z","labelOos":"wca-z"};